import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/random/base/arcsine';
import __var_2__ from '@stdlib/random/base/bernoulli';
import __var_3__ from '@stdlib/random/base/beta';
import __var_4__ from '@stdlib/random/base/betaprime';
import __var_5__ from '@stdlib/random/base/binomial';
import __var_6__ from '@stdlib/random/base/box-muller';
import __var_7__ from '@stdlib/random/base/cauchy';
import __var_8__ from '@stdlib/random/base/chi';
import __var_9__ from '@stdlib/random/base/chisquare';
import __var_10__ from '@stdlib/random/base/cosine';
import __var_11__ from '@stdlib/random/base/discrete-uniform';
import __var_12__ from '@stdlib/random/base/erlang';
import __var_13__ from '@stdlib/random/base/exponential';
import __var_14__ from '@stdlib/random/base/f';
import __var_15__ from '@stdlib/random/base/frechet';
import __var_16__ from '@stdlib/random/base/gamma';
import __var_17__ from '@stdlib/random/base/geometric';
import __var_18__ from '@stdlib/random/base/gumbel';
import __var_19__ from '@stdlib/random/base/hypergeometric';
import __var_20__ from '@stdlib/random/base/improved-ziggurat';
import __var_21__ from '@stdlib/random/base/invgamma';
import __var_22__ from '@stdlib/random/base/kumaraswamy';
import __var_23__ from '@stdlib/random/base/laplace';
import __var_24__ from '@stdlib/random/base/levy';
import __var_25__ from '@stdlib/random/base/logistic';
import __var_26__ from '@stdlib/random/base/lognormal';
import __var_27__ from '@stdlib/random/base/minstd';
import __var_28__ from '@stdlib/random/base/minstd-shuffle';
import __var_29__ from '@stdlib/random/base/mt19937';
import __var_30__ from '@stdlib/random/base/negative-binomial';
import __var_31__ from '@stdlib/random/base/normal';
import __var_32__ from '@stdlib/random/base/pareto-type1';
import __var_33__ from '@stdlib/random/base/poisson';
import __var_34__ from '@stdlib/random/base/randi';
import __var_35__ from '@stdlib/random/base/randn';
import __var_36__ from '@stdlib/random/base/randu';
import __var_37__ from '@stdlib/random/base/rayleigh';
import __var_38__ from '@stdlib/random/base/reviver';
import __var_39__ from '@stdlib/random/base/t';
import __var_40__ from '@stdlib/random/base/triangular';
import __var_41__ from '@stdlib/random/base/uniform';
import __var_42__ from '@stdlib/random/base/weibull';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace random
*/
var random = {};

/**
* @name arcsine
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/arcsine}
*/
setReadOnly( random, 'arcsine', __var_1__);

/**
* @name bernoulli
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/bernoulli}
*/
setReadOnly( random, 'bernoulli', __var_2__);

/**
* @name beta
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/beta}
*/
setReadOnly( random, 'beta', __var_3__);

/**
* @name betaprime
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/betaprime}
*/
setReadOnly( random, 'betaprime', __var_4__);

/**
* @name binomial
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/binomial}
*/
setReadOnly( random, 'binomial', __var_5__);

/**
* @name boxMuller
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/box-muller}
*/
setReadOnly( random, 'boxMuller', __var_6__);

/**
* @name cauchy
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/cauchy}
*/
setReadOnly( random, 'cauchy', __var_7__);

/**
* @name chi
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/chi}
*/
setReadOnly( random, 'chi', __var_8__);

/**
* @name chisquare
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/chisquare}
*/
setReadOnly( random, 'chisquare', __var_9__);

/**
* @name cosine
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/cosine}
*/
setReadOnly( random, 'cosine', __var_10__);

/**
* @name discreteUniform
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/discrete-uniform}
*/
setReadOnly( random, 'discreteUniform', __var_11__);

/**
* @name erlang
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/erlang}
*/
setReadOnly( random, 'erlang', __var_12__);

/**
* @name exponential
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/exponential}
*/
setReadOnly( random, 'exponential', __var_13__);

/**
* @name f
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/f}
*/
setReadOnly( random, 'f', __var_14__);

/**
* @name frechet
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/frechet}
*/
setReadOnly( random, 'frechet', __var_15__);

/**
* @name gamma
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/gamma}
*/
setReadOnly( random, 'gamma', __var_16__);

/**
* @name geometric
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/geometric}
*/
setReadOnly( random, 'geometric', __var_17__);

/**
* @name gumbel
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/gumbel}
*/
setReadOnly( random, 'gumbel', __var_18__);

/**
* @name hypergeometric
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/hypergeometric}
*/

setReadOnly( random, 'hypergeometric', __var_19__);

/**
* @name improvedZiggurat
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/improved-ziggurat}
*/
setReadOnly( random, 'improvedZiggurat', __var_20__);

/**
* @name invgamma
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/invgamma}
*/
setReadOnly( random, 'invgamma', __var_21__);

/**
* @name kumaraswamy
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/kumaraswamy}
*/
setReadOnly( random, 'kumaraswamy', __var_22__);

/**
* @name laplace
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/laplace}
*/
setReadOnly( random, 'laplace', __var_23__);

/**
* @name levy
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/levy}
*/
setReadOnly( random, 'levy', __var_24__);

/**
* @name logistic
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/logistic}
*/
setReadOnly( random, 'logistic', __var_25__);

/**
* @name lognormal
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/lognormal}
*/
setReadOnly( random, 'lognormal', __var_26__);

/**
* @name minstd
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/minstd}
*/
setReadOnly( random, 'minstd', __var_27__);

/**
* @name minstdShuffle
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/minstd-shuffle}
*/
setReadOnly( random, 'minstdShuffle', __var_28__);

/**
* @name mt19937
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/mt19937}
*/
setReadOnly( random, 'mt19937', __var_29__);

/**
* @name negativeBinomial
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/negative-binomial}
*/
setReadOnly( random, 'negativeBinomial', __var_30__);

/**
* @name normal
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/normal}
*/
setReadOnly( random, 'normal', __var_31__);

/**
* @name pareto1
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/pareto-type1}
*/
setReadOnly( random, 'pareto1', __var_32__);

/**
* @name poisson
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/poisson}
*/
setReadOnly( random, 'poisson', __var_33__);

/**
* @name randi
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/randi}
*/
setReadOnly( random, 'randi', __var_34__);

/**
* @name randn
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/randn}
*/
setReadOnly( random, 'randn', __var_35__);

/**
* @name randu
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/randu}
*/
setReadOnly( random, 'randu', __var_36__);

/**
* @name rayleigh
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/rayleigh}
*/
setReadOnly( random, 'rayleigh', __var_37__);

/**
* @name reviveBasePRNG
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/reviver}
*/
setReadOnly( random, 'reviveBasePRNG', __var_38__);

/**
* @name t
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/t}
*/
setReadOnly( random, 't', __var_39__);

/**
* @name triangular
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/triangular}
*/
setReadOnly( random, 'triangular', __var_40__);

/**
* @name uniform
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/uniform}
*/
setReadOnly( random, 'uniform', __var_41__);

/**
* @name weibull
* @memberof random
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/base/weibull}
*/
setReadOnly( random, 'weibull', __var_42__);


// EXPORTS //
export default random;

export { __var_1__ as arcsine, __var_2__ as bernoulli, __var_3__ as beta, __var_4__ as betaprime, __var_5__ as binomial, __var_6__ as boxMuller, __var_7__ as cauchy, __var_8__ as chi, __var_9__ as chisquare, __var_10__ as cosine, __var_11__ as discreteUniform, __var_12__ as erlang, __var_13__ as exponential, __var_14__ as f, __var_15__ as frechet, __var_16__ as gamma, __var_17__ as geometric, __var_18__ as gumbel, __var_19__ as hypergeometric, __var_20__ as improvedZiggurat, __var_21__ as invgamma, __var_22__ as kumaraswamy, __var_23__ as laplace, __var_24__ as levy, __var_25__ as logistic, __var_26__ as lognormal, __var_27__ as minstd, __var_28__ as minstdShuffle, __var_29__ as mt19937, __var_30__ as negativeBinomial, __var_31__ as normal, __var_32__ as pareto1, __var_33__ as poisson, __var_34__ as randi, __var_35__ as randn, __var_36__ as randu, __var_37__ as rayleigh, __var_38__ as reviveBasePRNG, __var_39__ as t, __var_40__ as triangular, __var_41__ as uniform, __var_42__ as weibull};